import Skeleton from "@material-ui/lab/Skeleton";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  TextField,
  MenuItem,
  Paper,
  Select,
  Typography,
  withStyles,
  InputAdornment,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { appService } from "../../App/app.service";
import { NumberFormatCustom } from "../../components/CustomNumberFormat";
import {
  customDateFormatterNew,
  dateFormatterMomentV2,
} from "../../util/customFunctions";
import DatePicker from "../../components/DatePicker_v2";
import SingleLevelDrilldown from "../../components/Drilldown/SingleLevelDrilldown";
import ExpectedAcvPage from "../../EnhancedInsights/NewWaterFall/ExpectedAcvPage";
import DrilldownBody from "../../components/Drilldown/Drilldown";
import RampAnalysisTable from "./RampAnalysisTable";
import TeamFilterHierarchy from "../../components/team-filter-hirarchy";
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";

const styles = (theme) => ({
  root: {},
  content: {},
  buttons: {
    display: "flex",
    justifyContent: "center",
    "& > *": { marginLeft: theme.spacing(1) },
  },
  inner: { height: 375, minWidth: 500 },
  chart: { height: "100%" },
  formControl: { maxWidth: 250 },
  datesFilterContainer: {
    marginTop: 5,
    marginRight: 5,
    marginBottom: 5,
    padding: 10,
    paddingBottom: 10,
    width: "32%",
    [theme.breakpoints.down("md")]: { width: "60%" },
    [theme.breakpoints.down("sm")]: { width: "100%" },
  },
  repTeamFilterContainer: {
    padding: 10,
    margin: 5,
    width: "29%",
    [theme.breakpoints.down("md")]: { width: "37%" },
    [theme.breakpoints.down("sm")]: { width: "100%", marginLeft: 0 },
  },
  acvFilterContainer: {
    padding: 10,
    margin: 5,
    paddingBottom: 2,
    width: "20%",
    [theme.breakpoints.down("md")]: { width: "35%", marginLeft: 0 },
    [theme.breakpoints.down("sm")]: { width: "60%" },
  },
  stageFilterContainer: {
    padding: 5,
    paddingTop: 10,
    margin: 5,
    paddingBottom: 10,
    width: "10%",
    [theme.breakpoints.down("md")]: { width: "20%" },
  },
  buttonContainer: { padding: 5, width: "5%", alignSelf: "center" },
});

const FILTERS = ["team"];

function RampAnalysis(props) {
  const { classes } = props;

  // Filter state
  const [rep, setRep] = useState(["All"]);
  const [team, setTeam] = useState(["All"]);
  const [CustType, setCustType] = useState(["All"]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [last, setLast] = useState("");
  const [groupby, setGroupby] = useState("None");
  const [repScope, setRepScope] = useState("Active");

  // Date picker bounds
  const [minDateForTo, setMinDateForTo] = useState("");
  const [maxDateForTo, setMaxDateForTo] = useState("");
  const [minDateForFrom, setMinDateForFrom] = useState("");
  const [maxDateForFrom, setMaxDateForFrom] = useState("");
  const [errorTextFrom, setErrorTextFrom] = useState("");
  const [errorTextTo, setErrorTextTo] = useState("");

  // Display state
  const [fromDisplay, setFromDisplay] = useState("");
  const [toDisplay, setToDisplay] = useState("");
  const [activeFrom, setActiveFrom] = useState("");
  const [activeTo, setActiveTo] = useState("");
  const [activelast, setActivelast] = useState("");

  // Drilldown state
  const [location, setLocation] = useState(null);
  const [secondLevelLocation, setSecondLevelLocation] = useState(null);
  const [drilldownFilters, setDrilldownFilters] = useState([]);
  const [drilldownTitle, setDrilldownTitle] = useState("");
  const [filtersForDrilldown, setFiltersForDrilldown] = useState([]);
  const [seriesFilter, setSeriesFilter] = useState(["All"]);
  const [series, setSeries] = useState(["All"]);

  const filtersLoaded = useRef(false);

  // Fetch filters on mount
  useEffect(() => {
    props.getRampAnalysisFilters();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // When filters load, set defaults
  useEffect(() => {
    if (props.RampAnalysisFilters === "" || filtersLoaded.current) return;
    filtersLoaded.current = true;

    const dateFilters = props.RampAnalysisFilters.filters.dateFilters;
    const defaultFilter = dateFilters.filter((s) => s.selectedByDefault === "Y")[0];
    const fromDateComponents = defaultFilter.value.split("-");
    const toDateComponents = props.RampAnalysisFilters.currentDate.split("-");
    const fromDateObj = new Date(parseInt(fromDateComponents[0]), parseInt(fromDateComponents[1]) - 1, parseInt(fromDateComponents[2]));
    const toDateObj = new Date(parseInt(toDateComponents[0]), parseInt(toDateComponents[1]) - 1, parseInt(toDateComponents[2]));
    const fromDate = `${fromDateObj.getMonth() + 1}-${fromDateObj.getDate()}-${fromDateObj.getFullYear()}`;
    const toDate = `${toDateObj.getMonth() + 1}-${toDateObj.getDate()}-${toDateObj.getFullYear()}`;

    const minDateSplit = props.RampAnalysisFilters.minMax.minDate.split("-");
    const minDate = new Date(parseInt(minDateSplit[0]), parseInt(minDateSplit[1]) - 1, parseInt(minDateSplit[2]));
    const maxDateSplit = props.RampAnalysisFilters.minMax.maxDate.split("-");
    const maxDate = new Date(parseInt(maxDateSplit[0]), parseInt(maxDateSplit[1]) - 1, parseInt(maxDateSplit[2]));

    let defaultvalueTeam;
    if (props.RampAnalysisFilters.filters !== "") {
      const val = props.RampAnalysisFilters.filters.parentChildrenTeamFilter;
      defaultvalueTeam = val.parentChildrenTeamFilter.defaultValueTeam;
    }

    const defaultLast = props.RampAnalysisFilters.defaultLast || "None";
    const defaultRepScope = props.RampAnalysisFilters.defaultRepScope || "Active";
    const isNone = defaultLast === "None";

    setMinDateForTo(minDate);
    setMaxDateForTo(maxDate);
    setMinDateForFrom(minDate);
    setMaxDateForFrom(maxDate);
    setTeam(defaultvalueTeam || ["All"]);
    setFrom(isNone ? "" : fromDate);
    setTo(isNone ? "" : toDate);
    setLast(isNone ? "None" : defaultFilter.value);
    setRepScope(defaultRepScope);
    setFromDisplay(isNone ? "" : customDateFormatterNew(fromDate));
    setToDisplay(isNone ? "" : customDateFormatterNew(toDate));
    setActiveFrom(isNone ? "" : fromDate);
    setActiveTo(isNone ? "" : toDate);

    // Auto-fetch data with defaults
    const apiFromDate = isNone ? "" : defaultFilter.value;
    const apiToDate = isNone ? "" : props.RampAnalysisFilters.currentDate;
    const groupbyFilters = { groupby: "None", repScope: defaultRepScope };
    let apiFilters = [];
    if (defaultvalueTeam && defaultvalueTeam.length > 0 && !defaultvalueTeam.includes("All")) {
      apiFilters.push({ name: "team", value: defaultvalueTeam, string: true });
    }
    props.getRampAnalysisData(apiFromDate, apiToDate, apiFilters, groupbyFilters);
  }, [props.RampAnalysisFilters]); // eslint-disable-line react-hooks/exhaustive-deps

  // Handlers
  const handleChange = useCallback((e) => {
    const value = e.target.value;
    if (value === "None") {
      setLast("None");
      setFrom("");
      setTo("");
      setErrorTextFrom("");
      setErrorTextTo("");
    } else if (value !== 1) {
      const fromParts = value.split("-");
      const toParts = props.RampAnalysisFilters.currentDate.split("-");
      const fromObj = new Date(parseInt(fromParts[0]), parseInt(fromParts[1]) - 1, parseInt(fromParts[2]));
      const toObj = new Date(parseInt(toParts[0]), parseInt(toParts[1]) - 1, parseInt(toParts[2]));
      setLast(value);
      setFrom(`${fromObj.getMonth() + 1}-${fromObj.getDate()}-${fromObj.getFullYear()}`);
      setTo(`${toObj.getMonth() + 1}-${toObj.getDate()}-${toObj.getFullYear()}`);
      setErrorTextFrom("");
      setErrorTextTo("");
    } else {
      // Custom — default from = min date, to = max date
      const minSplit = props.RampAnalysisFilters.minMax.minDate.split("-");
      const maxSplit = props.RampAnalysisFilters.minMax.maxDate.split("-");
      const minObj = new Date(parseInt(minSplit[0]), parseInt(minSplit[1]) - 1, parseInt(minSplit[2]));
      const maxObj = new Date(parseInt(maxSplit[0]), parseInt(maxSplit[1]) - 1, parseInt(maxSplit[2]));
      setFrom(`${minObj.getMonth() + 1}-${minObj.getDate()}-${minObj.getFullYear()}`);
      setTo(`${maxObj.getMonth() + 1}-${maxObj.getDate()}-${maxObj.getFullYear()}`);
      setLast(value);
    }
  }, [props.RampAnalysisFilters]);

  const handleChangeTeam = useCallback((filteredValues) => {
    const nonAllValues = filteredValues.filter((v) => v !== "All");
    if (filteredValues.includes("All")) {
      setTeam(["All"]);
    } else if (nonAllValues.length === 0) {
      // Keep current
    } else {
      setTeam(nonAllValues);
    }
  }, []);

  const handleChangeFilter = useCallback((e) => {
    const { name, value } = e.target;
    if (name === "groupby") setGroupby(value);
    else if (name === "repScope") setRepScope(value);
  }, []);

  const setFromDate = useCallback((date) => {
    const split = to.split("-");
    const toDate = new Date(parseInt(split[2]), parseInt(split[0]) - 1, parseInt(split[1]));
    const newFrom = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
    if (new Date(date) > toDate) {
      setFrom(newFrom);
      setErrorTextFrom("From date cannot be later than the To date");
    } else {
      setFrom(newFrom);
      setErrorTextFrom("");
      setErrorTextTo("");
    }
  }, [to]);

  const setToDate = useCallback((date) => {
    const split = from.split("-");
    const fromDate = new Date(parseInt(split[2]), parseInt(split[0]) - 1, parseInt(split[1]));
    const newTo = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
    if (new Date(date) < fromDate) {
      setTo(newTo);
      setErrorTextFrom("To date cannot be earlier than the From date");
    } else {
      setTo(newTo);
      setErrorTextTo("");
      setErrorTextFrom("");
    }
  }, [from]);

  const passFiltersForDrilldown = useCallback(() => {
    let filtersArray = [];
    if (!series.includes("All")) filtersArray.push({ title: "Series", value: series });
    if (!team.includes("All")) filtersArray.push({ title: "Team", value: team });
    if (!CustType.includes("All")) filtersArray.push({ title: "Customer Type", value: CustType });
    return filtersArray;
  }, [series, team, CustType]);

  const plot = useCallback(() => {
    let filters = FILTERS
      .map((f) => ({
        name: f,
        value: f === "team"
          ? team.includes("All")
            ? team
            : team.map((s) =>
                props.RampAnalysisFilters.filters.teams.filter((r) => r.Display_Name === s)[0].Display_Name
              )
          : [],
        string: "true",
      }))
      .filter((f) => !f.value.includes("All"));

    const isNone = last === "None";
    const fromDate = isNone ? "" : `${from.split("-")[2]}-${from.split("-")[0]}-${from.split("-")[1]}`;
    const toDate = isNone ? "" : `${to.split("-")[2]}-${to.split("-")[0]}-${to.split("-")[1]}`;
    const groupbyFilters = { groupby, repScope };

    props.getRampAnalysisData(fromDate, toDate, filters, groupbyFilters);

    setFromDisplay(isNone ? "" : customDateFormatterNew(from));
    setToDisplay(isNone ? "" : customDateFormatterNew(to));
    setActiveFrom(from);
    setActiveTo(to);
    setFiltersForDrilldown(passFiltersForDrilldown());
    setActivelast(last);
    setSeriesFilter(series);
  }, [from, to, last, team, groupby, repScope, series, props.RampAnalysisFilters, passFiltersForDrilldown]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeLocation = useCallback((loc, repName, quarter, teamName) => {
    if (loc !== "overview") {
      let filters = [
        { name: "closed_fiscal_quarter", value: typeof quarter === "string" ? [quarter] : quarter, string: true },
        { name: "Owner_Name", value: [repName], string: true },
      ];
      if (teamName) filters.push({ name: "team", value: typeof teamName === "string" ? [teamName] : teamName });
      if (team[0] !== "All") filters.push({ name: "team", value: typeof team === "string" ? [team] : team });

      const drilldownfilters = [
        { title: "Rep", value: repName },
        { title: "Closed Fiscal Quarter", value: quarter },
      ];
      props.getRampAnalysisDrilldown(filters);
      setLocation(loc);
      setDrilldownTitle("Ramp Analysis");
      setDrilldownFilters([...drilldownfilters, ...filtersForDrilldown]);
    } else {
      props.clearDrilldownData();
    }
  }, [team, filtersForDrilldown]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeLocationBack = useCallback((loc) => {
    setLocation(loc);
    setSecondLevelLocation(loc);
  }, []);

  const handleSecondLevelDrilldown = useCallback((loc, oppId) => {
    setLocation(loc);
    setSecondLevelLocation(loc);
    props.getOpenOppData(oppId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const stepBack = useCallback(() => {
    setLocation("drilldownOnGraph");
    setSecondLevelLocation("");
    props.clearExpectedAcvData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Derived
  let teamObject;
  if (props.RampAnalysisFilters !== "") {
    teamObject = props.RampAnalysisFilters.filters.parentChildrenTeamFilter;
  }

  return (
    <Grid container className={classes.gridContainer}>
      <Grid className={classes.grid} item style={{ marginBottom: 10, marginLeft: 25 }} xs={12}>
        <AddHeaderDescriptionWithHelperText
          header="Ramp Analysis"
          description="Analyze ramp velocity by rep and team."
          helperTextCharts={props.helperTextCharts}
        />

        {props.RampAnalysisFilters !== "" ? (
          <>
            <Grid container xs={12} alignItems="flex-start" style={{ marginBottom: 5 }}>
              {/* Hiring Time Frame */}
              <Grid xs={5} item container className={classes.datesFilterContainer} component={Paper}>
                <Grid item xs={4} style={{ paddingTop: 0 }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel id="select-last-label" style={{ color: "#4472c4" }}>
                      Hiring Time Frame - Last:
                    </InputLabel>
                    <Select
                      labelId="select-last-label"
                      id="select-last"
                      value={last}
                      onChange={handleChange}
                      label="Last:"
                      name="last"
                    >
                      {[
                        { text: "None", value: "None" },
                        { text: "Custom", value: 1 },
                        ...props.RampAnalysisFilters.filters.dateFilters,
                      ].map((y) => (
                        <MenuItem key={y.text} value={y.value}>
                          {y.text}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4} style={{ paddingLeft: 10 }}>
                  <DatePicker
                    label="From start of:"
                    setDate={setFromDate}
                    disabled={last !== 1}
                    min={minDateForFrom}
                    max={maxDateForFrom}
                    current={last === "None" ? null : from}
                    errorText={errorTextFrom}
                  />
                </Grid>
                <Grid item xs={4} style={{ paddingLeft: 10 }}>
                  <DatePicker
                    label="To end of:"
                    setDate={setToDate}
                    disabled={last !== 1}
                    min={minDateForTo}
                    max={maxDateForTo}
                    current={last === "None" ? null : to}
                    errorText={errorTextTo}
                  />
                </Grid>
              </Grid>

              {/* Group By */}
              <Grid item container xs={2} className={classes.repTeamFilterContainer} component={Paper}>
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                  <FormControl fullWidth>
                    <InputLabel id="groupby-label">Group By:</InputLabel>
                    <Select
                      labelId="groupby-label"
                      id="groupby"
                      value={groupby}
                      onChange={handleChangeFilter}
                      label="groupby"
                      name="groupby"
                      data-test="group-by"
                    >
                      <MenuItem value="None">None</MenuItem>
                      <MenuItem value="Team">Team</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* Rep Scope */}
              <Grid item xs={2} container className={classes.repTeamFilterContainer} component={Paper}>
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                  <FormControl fullWidth>
                    <InputLabel id="repscope-label">Rep Scope:</InputLabel>
                    <Select
                      labelId="repscope-label"
                      id="repscope"
                      value={repScope}
                      onChange={handleChangeFilter}
                      label="Rep Scope"
                      name="repScope"
                    >
                      <MenuItem value="Active">Active</MenuItem>
                      <MenuItem value="All">All</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* Team Filter */}
              <Grid item xs={2} container className={classes.repTeamFilterContainer} component={Paper}>
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                  <TeamFilterHierarchy
                    label="Team:"
                    value={team}
                    data={teamObject.parentChildrenTeamFilter.filters}
                    onTeamChange={handleChangeTeam}
                    name="team"
                    disabled={!rep.includes("All")}
                    labelColorCondition={!team.includes("All")}
                    renderValue={(selected) => selected.join(", ")}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.parentValue + option.label}
                  />
                </Grid>
              </Grid>

              {/* GO Button */}
              <Grid container item style={{ marginBottom: 10, padding: 10 }} justify="space-between" xs={4} lg={2}>
                <Grid item xs={4} xl={3} container justify="flex-end">
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={plot}
                    disabled={errorTextFrom !== "" || errorTextTo !== ""}
                  >
                    GO
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          <Grid item container component={Card} style={{ margin: "1rem" }} justify="center">
            <Skeleton variant="react" animation="wave" height={120} width="90%" style={{ margin: "1rem" }} />
          </Grid>
        )}

        {/* Table */}
        <Grid item xs={12} className={classes.grid} container justify="center">
          <Grid item xs={12} style={{ marginBottom: "2rem", paddingBottom: "2rem" }}>
            <Card style={{ margin: "auto", width: "100%" }} raised={true}>
              {props.RampAnalysisData !== "" ? (
                <Grid item container xs={12} justify="center">
                  <Typography
                    variant="h2"
                    style={{ margin: "1rem", display: "flex", justifyContent: "center", padding: "1rem" }}
                  >
                    Ramp Analysis ($K)
                  </Typography>
                  <RampAnalysisTable
                    data={props.RampAnalysisData.data}
                    timeFrame={props.RampAnalysisData.timeFrame}
                    groupby={props.RampAnalysisData.groupby}
                    groupbyColumn={props.RampAnalysisData.groupbyColumn}
                    uniqueTeams={props.RampAnalysisData.uniqueTeams}
                    handleChangeLocation={handleChangeLocation}
                    dataTest="Ramp Analysis"
                  />
                  {props.RampAnalysisData.data.map((c) => c.Term_Date).filter(Boolean).length > 0 && (
                    <Grid item container xs={10} justify="flex-start" alignItems="flex-end" style={{ marginBottom: "1rem", marginLeft: "-205px" }}>
                      <Typography variant="body2">
                        <span style={{ color: "#ED7D31" }}>*</span>&nbsp;
                        Excluded from analysis for time periods where no quota data is available.
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              ) : (
                <Grid item container justify="center">
                  <Skeleton variant="react" animation="wave" height={120} width="90%" style={{ margin: "1rem" }} />
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>
      </Grid>

      {/* Drilldown */}
      {location === "drilldownOnGraph" && (
        <Grid item xs={12} style={{ position: "absolute", width: "100%", marginTop: "30px" }}>
          <SingleLevelDrilldown header="Ramp Analysis" back={handleChangeLocationBack} filters={drilldownFilters}>
            <DrilldownBody
              body={props.drilldownOnGraphData}
              showQuota={true}
              company={props.company}
              header="Ramp Analysis"
              handleSecondLevelDrilldown={handleSecondLevelDrilldown}
            />
          </SingleLevelDrilldown>
        </Grid>
      )}
      {secondLevelLocation === "drilldownOppId" && (
        <Grid item xs={12} style={{ position: "absolute", width: "100%", marginTop: "30px" }}>
          <SingleLevelDrilldown header="Opportunity Change Events" back={handleChangeLocationBack} stepBack={stepBack} filters={[]}>
            <ExpectedAcvPage body={props.ExpectedAcvData} />
          </SingleLevelDrilldown>
        </Grid>
      )}
    </Grid>
  );
}

const mapStateToProps = (state) => {
  const { RampAnalysisData, RampAnalysisFilters, drilldownOnGraphData, currentFilters, user, ExpectedAcvData } = state.app;
  return {
    RampAnalysisFilters,
    RampAnalysisData,
    drilldownOnGraphData,
    currentFilters,
    company: user.company,
    ExpectedAcvData,
    helperTextCharts: user.elements.flatMap((item) => item.charts || []),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getRampAnalysisFilters: () => {
    dispatch({ type: "get_ramp_analysis_filters_request" });
    appService.getRampAnalysisFilters().then(
      (json) => {
        dispatch({ type: "get_ramp_analysis_filters_success", json });
      },
      (error) => {
        if (typeof error === "object") dispatch({ type: "get_ramp_analysis_filters_failure", error: "Something went wrong" });
        else dispatch({ type: "get_ramp_analysis_filters_failure", error });
      }
    );
  },
  getRampAnalysisDrilldown: (filters) => {
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.getRampAnalysisDrilldown(filters).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].sort((a, b) => (a.ACV > b.ACV ? -1 : 1));
        tempOpportunities = tempOpportunities.map((item, index) => ({ ...item, OppNo: index + 1 }));
        json.message = {
          ...json,
          columns: json.message.columns,
          count_acv: json.message.opportunities[0],
          opportunities: tempOpportunities,
        };
        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object") dispatch({ type: "get_drilldown_on_graph_failure", error: "Something went wrong" });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
  clearDrilldownData: () => { dispatch({ type: "clear_drilldown_data" }); },
  getRampAnalysisData: (from, to, filters, groupbyFilters) => {
    dispatch({ type: "get_ramp_analysis_data_request" });
    appService.getRampAnalysisData(from, to, filters, groupbyFilters).then(
      (json) => { dispatch({ type: "get_ramp_analysis_data_success", json }); },
      (error) => {
        if (typeof error === "object") dispatch({ type: "get_ramp_analysis_data_failure", error: "Something went wrong" });
        else dispatch({ type: "get_ramp_analysis_data_failure", error });
      }
    );
  },
  getOpenOppData: (oppId) => {
    dispatch({ type: "get_expectedAcv_drilldown_data_request" });
    appService.getWaterfallOppData(oppId).then(
      (json) => { dispatch({ type: "get_expectedAcv_drilldown_data_success", json }); },
      (error) => {
        if (typeof error === "object") dispatch({ type: "get_expectedAcv_drilldown_data_failure", error: "Something went wrong" });
        else dispatch({ type: "get_expectedAcv_drilldown_data_failure", error });
      }
    );
  },
  clearExpectedAcvData: () => { dispatch({ type: "clear_expected_acv_data" }); },
});

const connectedRampAnalysis = connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RampAnalysis));
export default connectedRampAnalysis;
